import { Component, Input, OnInit, signal, WritableSignal } from '@angular/core';
import { LMBuilderContext, LMBuilderModel } from "@components/builder/services/lm-builder-model.service";

@Component({
  selector:    'lm-builder-totaling',
  standalone: false,
  templateUrl: './lm-builder-totaling.component.html',
  styleUrl: './lm-builder-totaling.component.scss',
})
export class LMBuilderTotalingComponent implements OnInit {
  @Input() spec!: LMListPSpec;

  columnTotalHelpTitle: WritableSignal<string> = signal(Soho.Locale.translate('ColumnTotalWidgetTitle'));
  columnTotalHelpText: WritableSignal<string> = signal(Soho.Locale.translate('ColumnTotalHelpText'));
  summaryTotalHelpTitle: WritableSignal<string> = signal(Soho.Locale.translate('SummaryTotalWidgetTitle'));
  summaryTotalHelpText: WritableSignal<string> = signal(Soho.Locale.translate('SummaryTotalHelpText'));

  protected readonly LMBuilderModel = LMBuilderModel;
  private totalingBuilderContext: LMBuilderContext = 'UNKNOWN';

  constructor(
      private lmBuilderModel: LMBuilderModel
  ) {
    //no-op
  }
  ngOnInit(): void {
    this.lmBuilderModel.builderContext$.subscribe(builderContext => {
      if (builderContext === 'TOTALING') {
        this.lmBuilderModel.builderContext$.next(this.totalingBuilderContext);
      }
    });
  }
  accordionExpanded(builderContext: LMBuilderContext) {
    this.totalingBuilderContext = builderContext;
    this.lmBuilderModel.builderContext$.next(this.totalingBuilderContext);
  }

  protected readonly Soho = Soho;
}
